module.exports = __webpack_public_path__ + "images/emoji/oncoming_automobile.40e0a7281441f7fcd050.png";